import React, { useState } from "react";

import WorkServiceOrderList from "./WorkServiceOrderList";
import WorkServiceOrderForm from "./WorkServiceOrderForm";

const WorkServiceOrder = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <WorkServiceOrderForm
          addForm={setFromIsShown}
          update={upData}
          sId={serviceId}
        />
      ) : (
        <WorkServiceOrderList
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};

export default WorkServiceOrder;
